import React from 'react'

import { useClass } from '@/hooks/useClass'

export type SelectProps = React.ComponentProps<'select'> & {
  options: {
    label: string
    value: string
  }[]
  hasFirstValue?: boolean
  error?: string
}

export const Select = ({
  options,
  className,
  error,
  ...props
}: SelectProps) => {
  const selectClass = useClass(
    'bg-transparent border border-ui-2 rounded-[8px] w-full h-[52px] px-16 font-bold',
    className
  )
  const newOptions = options

  return (
    <fieldset>
      <select className={selectClass} {...props}>
        {newOptions.map(({ label, value }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      {!!error && <p className="pt-4 text-error">{error}</p>}
    </fieldset>
  )
}
